import styled from 'styled-components'

export const StyledImageContainer = styled.section`
  display: flex;
  border-radius: 4px;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
`
export const StyledImage = styled.img`
  height: 100px;
  width: 112px;
  border-radius: 4px;
  margin: 0 auto 10px auto;
`
